<template>
  <main class="main page-inside contacts-page">
    <div class="main-wrapper">
      <div class="section hero-section">
        <div class="wrapper">
          <div class="contact">
            <div class="left">
              <img src="./../images/arrows-right.svg" class="arrows-right"/>
              <div class="title medium upper">
                <b>{{ $t('NEED ADDITIONAL HELP?') }}</b>
                <br>
                <span>{{ $t('CONTACT US') }}</span>
              </div>
              <div class="info">
                <div class="title small">{{ $t('via') }}</div>
                <div class="desc">{{ $t('SUPPORT EMAIL') }}: {{ $parent.settings.support_email }}</div>
              </div>
              <div class="info">
                <div class="title small">{{ $t('our social media') }}</div>
                  <a :href="item.url" target="_blank" class="social" v-for="(item, i) in $parent.socials" :key="i">
                    <img :src="$parent.imgDomain + item.image" class="img"/>
                    <div class="desc">{{ item.title }}</div>
                  </a>
              </div>
            </div>
            <div class="right">
              <div class="right-wrapper">
                <div class="title regular">{{ $t('FILL THE FORM') }}</div>
                <div class="desc">{{ $t('AND WE WILL CONTACT YOU') }} </div>
                <div class="content form-fields form-fields-wrapper">
                  <label>
                    <div class="desc">{{ $t('Name') }}:</div>
                    <input type="text" :placeholder="$t('Name')" v-model="name"/>
                  </label>
                  <label>
                    <div class="desc">{{ $t('Email') }}:</div>
                    <input type="text" :placeholder="$t('Email')" v-model="email"/>
                  </label>
                  <label>
                    <div class="desc">{{ $t('Your message') }}:</div>
                    <textarea :placeholder="$t('Message')" v-model="message"></textarea>
                  </label>
                  <button class="button" @click="submit">[ {{ $t('SEND') }} ]</button>
                  <transition name="fade">
                    <div v-if="$parent.successMessage" class="desc small green">{{$parent.successMessage}}</div>
                  </transition>
                  <transition name="slide">
                    <div v-if="$parent.error" class="error-desc desc red">{{$parent.error}}</div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <div class="contact-info">
            <div class="desc">
              {{ $t('This website is operated by') }} {{ $parent.settings.company_name }}, <br/>
              {{ $t('Registry code') }}: {{ $parent.settings.company_reg_number }}, <br/>
              {{ $t('Legal address') }}: {{ $parent.settings.company_address }}
            </div>
          </div>
        </div>
      </div>
      <div class="section nav-bottom-section">
        <Nav />
      </div>
    </div>
  </main>
</template>
<script>
import Nav from '../components/Nav.vue'

export default {
  name: 'Faq',
  props: ['categories'],
  components: {
    Nav
  },
  data: function() {
    return {
      faq: [],
      activePanels: [],
      name: '',
      email: '',
      message: ''
    }
  },
  mounted() {
    this.$http.get(process.env.VUE_APP_API + 'faq')
      .then((res) => {
          this.faq = res.data.payload;
      })
      .catch(() => {
        
      })
  },
  methods: {
    togglePanel(index) {
      if (this.isActivePanel(index)) {
        this.activePanels.splice(this.activePanels.indexOf(index), 1)
      } else {
        this.activePanels.push(index)
      }
    },
    isActivePanel(index) {
      return this.activePanels.includes(index)
    },
    submit() {
      let data = {
        "name": this.name,
        "email": this.email,
        "message": this.message
      }
      this.$emit('sendContactForm', data);
    },
  }
}
</script>